import type React from 'react';
import { cn } from '@/lib/utils';

interface TitleProps {
	title: string;
	subtitle?: string;
}

const Title = ({ title, subtitle = '' }: TitleProps): React.JSX.Element => {
	return (
		<>
			<h1
				data-testid="page-title"
				className={cn(
					'text-left sm:text-center text-2xl md:text-3xl leading-tight font-bold',
					// Keep the title close to its subtitle (they read as one unit); without a
					// subtitle the heading needs its own breathing room before the body (#494).
					subtitle ? 'mb-4' : 'mb-5 sm:mb-8'
				)}
			>
				{title}
			</h1>
			{subtitle && (
				<h2
					data-testid="page-subtitle"
					className="text-left sm:text-center text-lg sm:text-xl lg:text-2xl mb-7 sm:mb-12 leading-snug font-medium text-primary"
				>
					{subtitle}
				</h2>
			)}
		</>
	);
};

export default Title;
